import "../index.scss";

const SeverityBadge = ({ severity }) => {
  if (!severity) return null;
  return (
    <span className={`cred-scan-severity-badge ${severity}`}>
      {severity}
    </span>
  );
};

export default SeverityBadge;
